// dataService.js — Fetches JSON data from S3
import config from '../config/config';

export async function fetchData(key) {
  const path = config.DATA_PATHS[key];
  if (!path) throw new Error(`Unknown data key: ${key}`);

  const url = `${config.S3_DATA_BASE_URL}${path}`;
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Failed to fetch ${key} data: ${response.status} ${response.statusText}`);
  }

  return response.json();
}
